import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.startInterval();
  }

  disconnect() {
    if (this.interval === undefined) return;

    this.clearInterval();
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = undefined;
  }

  startInterval() {
    this.interval = setInterval(this.heartbeat.bind(this), 30 * 1000);
  }

  heartbeat() {
    const isPresentInDom = document.body.contains(this.element);

    if (!isPresentInDom) {
      this.clearInterval();
      return;
    }

    if (!document.hidden) {
      let request = new XMLHttpRequest();
      request.open("PATCH", this.data.get("url"));
      request.send();
    }
  }
}
